var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:{
          'pp-ui-button': _vm.applyStyles,
          'pp-ui-hidden': !_vm.airplay.canCast,
          'pp-ui-enabled': _vm.airplay.casting
        },on:{"click":_vm.onClick}},[_vm._t("default",function(){return [_c('AirPlay')]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }